import { useContext } from 'react';
import {
    Table, TableBody, TableCell, Tooltip, Zoom,
    TableHead, TablePagination, TableRow, IconButton, TableFooter, Typography
} from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import { countriesContext } from '../CountriesContext';
import { CircleLoader, NumberFormat } from 'components';
import { Link } from 'react-router-dom';
import ReferenceDataKey from 'helpers/enums/ReferenceDataKey';
import { applicationContext } from 'helpers/services';
import { KeyValuePair } from 'helpers';

let Results = () => {
    let service = useContext(countriesContext);
    let appService = useContext(applicationContext);

    return (
        <div>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Code</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Currency</TableCell>
                            <TableCell>Locale</TableCell>
                            <TableCell align='center'>Override tax rate</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {service.countries.length > 0 &&
                            service.countries
                                .map((country, index) =>
                                    <TableRow hover key={index}>
                                        <TableCell>{country.code}</TableCell>
                                        <TableCell>{country.name}</TableCell>
                                        <TableCell>{country.currencyCode} - {country.currencySymbol}</TableCell>
                                        <TableCell>
                                            {appService.referenceData[ReferenceDataKey.Locale]
                                                .filter((x: KeyValuePair<string, string>) => country.locales.indexOf(x.key) !== -1)
                                                .map(x => x.value)
                                                .join(", ")
                                            }
                                        </TableCell>
                                        <TableCell align='center'>
                                            {country.taxRateOverride
                                                ? <NumberFormat amount={country.taxRateOverride} suffix='%' />
                                                : 'Use default'
                                            }
                                        </TableCell>
                                        <TableCell align="right">
                                            <Tooltip TransitionComponent={Zoom} title="Edit">
                                                <IconButton
                                                    color="primary"
                                                    size="small"
                                                    component={Link}
                                                    to={{
                                                        pathname: `/admin/country/edit/${country.id}`,
                                                    }}
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip TransitionComponent={Zoom} title="Delete">
                                                <IconButton
                                                    color="secondary"
                                                    size="small"
                                                    onClick={() => service.deleteCountry(country.id)}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                )}
                    </TableBody>
                    {service.countries.length === 0 &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={6}>
                                    <Typography variant="subtitle2">No countries found</Typography>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
            }
            {service.isLoading === false &&
                <TablePagination
                    component="div"
                    count={service.recordCount}
                    onPageChange={service.handleChangePage}
                    page={service.search.pageNr}
                    rowsPerPage={service.search.pageSize}
                    rowsPerPageOptions={[service.search.pageSize]}
                />
            }
        </div>
    );
}

export default Results;